import SVGPanBlock from 'assets/svgpanblock'
import React, { PropsWithChildren, useState } from 'react'
import { AlertDialogType, iAlertDialog } from './AlertDIalogContextType'

const defalutAlertDialogContext = {
  title: 'Blacklisted PAN',
  midIcon: <SVGPanBlock />,
  subText: 'This PAN is blacklisted and can’t be used for onboarding',
  actionName: 'Ok',
  openDialog: false,
  onActionClick: null,
}

export const AlertDialogContext = React.createContext<AlertDialogType | null>(null)

const AlertDialogProvider: React.FC<PropsWithChildren<object>> = ({ children }) => {
  const [alertDialog, setAlertDialog] = useState<iAlertDialog>(defalutAlertDialogContext)
  const updateAlertDialog = (alertDialog: iAlertDialog) => {
    setAlertDialog((prev) => ({ ...prev, ...alertDialog }))
  }
  return (
    <AlertDialogContext.Provider value={{ alertDialog, updateAlertDialog }}>
      {children}
    </AlertDialogContext.Provider>
  )
}
export default AlertDialogProvider
